import React from "react";
import { Link } from "react-router-dom";
import { Trash2, Bookmark } from "lucide-react";
import Shell from "../components/Shell";
import ProjectGridCard from "../components/ProjectGridCard";
import { useApp } from "../context/AppContext";
import { UBot } from "../components/UBot";

export default function SavedPage() {
  const { saved, toggleSave, auth } = useApp();
  const [, force] = React.useState(0);

  return (
    <Shell>
      <div className="mx-auto w-full max-w-6xl px-4 py-6">
        <h1 className="font-display text-[28px] font-extrabold text-white">Saved</h1>
        <p className="mb-5 text-on-dark-muted">Projects you're keeping an eye on</p>

        {!auth.authenticated && saved.length > 0 && (
          <Link to="/signin" className="mb-5 inline-block rounded-pill bg-white/5 px-4 py-2 text-[13px] font-semibold text-gold-400 ring-1 ring-white/10">
            Sign in to keep your saved list on every device →
          </Link>
        )}

        {saved.length === 0 ? (
          <div className="flex flex-col items-center gap-3 py-16 text-center" data-testid="saved-empty">
            <UBot size={96} />
            <h2 className="font-display text-[22px] font-bold">Nothing saved yet</h2>
            <p className="max-w-xs text-on-dark-muted">Tap ⭐ on any project to keep it here for later.</p>
            <Link to="/deck" className="mt-2 rounded-pill bg-gold-500 px-6 py-3 font-bold text-navy-900">Start swiping</Link>
          </div>
        ) : (
          <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4">
            {saved.map((p) => (
              <div key={p.slug} className="relative" data-testid={`saved-${p.slug}`}>
                <ProjectGridCard project={p} />
                <button onClick={() => { toggleSave(p); force((n) => n + 1); }} aria-label="Remove"
                  className="absolute right-2 top-2 z-10 rounded-full bg-navy-950/70 p-1.5 text-white backdrop-blur">
                  <Trash2 size={15} />
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </Shell>
  );
}
